import { createFileRoute } from '@tanstack/react-router'
import { CreateAccount } from '../components/create-account'

// "I buy gas": a personal account; cylinders are added from the portal afterwards.
export const Route = createFileRoute('/signup')({ component: () => <CreateAccount kind="customer" /> })
